export default "__VITE_ASSET__34pMIznO__"